module.exports = __webpack_public_path__ + "8a422611d0bd4451914900a50d4237d5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-nestable/dist/Icon/icon-minus-gray.svg
// module id = 1561
// module chunks = 0